






























































import Vue from "vue";

import store from "@/store";

export default Vue.extend({
  name: "Menu",
  computed: {
    languages() {
      return store.state.languages;
    },
    general() {
      return store.getters.general;
    },
    sortAlgorithms() {
      return store.getters.sortAlgorithms;
    },
    searchAlgorithms() {
      return store.getters.searchAlgorithms;
    },
    dataStructures() {
      return store.getters.dataStructures;
    },
  },
  methods: {
    getLink(algorithm: string) {
      return algorithm.split(" ").join("-").toLowerCase();
    },
  },
});
